import { loadScene } from 'components/async/scene';
import ModuleRoutes from 'components/routing/ModuleRoutes';
import { Module } from 'modules/security/types/modules';
import * as React from 'react';
import { Route } from 'react-router-dom';
import { IMPORTED_ORGANIZATION_BASE_ROUTE, IMPORTED_ORGANIZATION_MODULE_KEY } from '../constants';

type Props = {
  allowedModules: Module[];
};

const ImportedOrganizationsScene = loadScene('importedOrganizations', 'ImportedOrganizationsScene');
const ImportedOrganizationDetailScene = loadScene('importedOrganizations', 'ImportedOrganizationDetailScene');

const ImportedOrganizationsRoutes: React.FunctionComponent<Props> = ({ allowedModules }: Props) => {
  return (
    <ModuleRoutes allowedModules={allowedModules} moduleKey={IMPORTED_ORGANIZATION_MODULE_KEY}>
      <React.Fragment>
        <Route path={[IMPORTED_ORGANIZATION_BASE_ROUTE]} exact>
          <ImportedOrganizationsScene />
        </Route>
        <Route path={`${IMPORTED_ORGANIZATION_BASE_ROUTE}/:subroute`}>
          <ImportedOrganizationDetailScene />
        </Route>
      </React.Fragment>
    </ModuleRoutes>
  );
};

export default ImportedOrganizationsRoutes;
